import { render, staticRenderFns } from "./BasicAiConfig.vue?vue&type=template&id=a4061bb6&scoped=true&"
import script from "./BasicAiConfig.vue?vue&type=script&lang=js&"
export * from "./BasicAiConfig.vue?vue&type=script&lang=js&"
import style0 from "./BasicAiConfig.vue?vue&type=style&index=0&id=a4061bb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4061bb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\001.src\\003.aikl_wrokspace\\aikl_v2_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4061bb6')) {
      api.createRecord('a4061bb6', component.options)
    } else {
      api.reload('a4061bb6', component.options)
    }
    module.hot.accept("./BasicAiConfig.vue?vue&type=template&id=a4061bb6&scoped=true&", function () {
      api.rerender('a4061bb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mng/BasicAiConfig.vue"
export default component.exports